// FILECONTENT_START src/common/components/Inputs/Switch/Switch.tsx
import {
  Box,
  BoxProps,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
  Typography,
} from "@mui/material";
import { ColorIndicatorProps } from "../types";

export interface SwitchProps
  extends ColorIndicatorProps,
    Omit<
      MuiSwitchProps,
      "error" | "onChange" | "onBlur" | "value" | "checked"
    > {
  error?: string;
  helperText?: string;
  mask?: string;
  onChange?: Function;
  onBlur?: Function;
  onChangeByKeyPress?: Function;
  useDelayedKeystrokes?: boolean;
  unmask?: boolean;
  editable?: boolean;
  isDirty?: boolean;
  value?: boolean;
  label?: string;
  required?: boolean;
  numeric?: boolean;
  boxProps?: BoxProps;
}

export default function Switch({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  onChangeByKeyPress,
  editable,
  useDelayedKeystrokes = true,
  isDirty,
  label,
  numeric,
  indicatorColor,
  indicatorOpacity,
  boxProps,
  ...props
}: SwitchProps) {
  return (
    <Box {...boxProps}>
      <MuiSwitch
        checked={value ? true : false}
        onChange={(event, checked) => {
          const numericChecked: any = checked ? 1 : 0;
          onChange &&
            onChange({
              target: {
                value: numeric ? (numericChecked as never) : (checked as never),
              },
            });
        }}
        {...props}
      />
      {label ? (
        <Typography
          component="span"
          sx={{
            color: theme =>
              props.disabled ? theme.palette.action.disabled : undefined,
          }}
        >{` ${label}`}</Typography>
      ) : (
        ""
      )}
    </Box>
  );
}

// FILECONTENT_END src/common/components/Inputs/Switch/Switch.tsx
